"use client";

import { useEffect } from "react";
import { initMixpanel } from "./mixpanel.service";

export function MixpanelProvider() {
  useEffect(() => {
    initMixpanel();
  }, []);

  return null;
}
